import { Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import { useTranslation } from 'Hooks/useTranslation';
import { bullets } from 'Containers/PreviousYears/utils';
import { PreviousYearSatStatus } from 'Containers/PreviousYears/types';
import * as Styled from './styles';

const FaqToReturn = ({ data }: { data: PueblaPreviousYearsResponse }): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const isPending =
    data &&
    data?.records?.find(item => item?.lastStatus === PreviousYearSatStatus.NOT_AVAILABLE) &&
    !data?.records?.some(item => item.isRecoverable);

  const refundType = isPending ? PreviousYearSatStatus.NOT_AVAILABLE : data?.refundStatusType;
  return (
    <Styled.DetailAccordion size="S">
      <Text type="paragraphs" color="dark" size="S_L_S">
        {t('Faq.previousYears.toReturn')}
      </Text>
      <Styled.FaqContainer direction="column" justify="flex-start" gap="dimension_16">
        {bullets[refundType].map(item => (
          <>
            <Text type="paragraphs" color="dark" size="S_L_S">
              {t(item.question)}
            </Text>
            <Text type="paragraphs" color="dark" size="S_S_S">
              {t(item.answer)}
            </Text>
          </>
        ))}
      </Styled.FaqContainer>
    </Styled.DetailAccordion>
  );
};

export default FaqToReturn;
